(function(){
  function initTicker(root){
    if(!root) return;
    var rail = root.querySelector('#promoTickerRail');
    if(!rail) return;

    var storageKey = 'promoTickerPaused';
    var prefersReduced = false;
    try {
      prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch(e) {}

    var stickyPaused = false; // user toggled
    var focusPaused = false;  // keyboard focus state

    function applyPause(){
      var paused = !!(prefersReduced || stickyPaused || focusPaused);
      root.classList.toggle('is-paused', paused);
    }

    var persisted = null;
    try { persisted = localStorage.getItem(storageKey); } catch(e) {}
    stickyPaused = (persisted === 'true');
    applyPause();

    // Hover keeps the repeating announcement scrolling.

    // Focus pause (keyboard)
    root.addEventListener('focusin', function(){ focusPaused = true; applyPause(); });
    root.addEventListener('focusout', function(){ focusPaused = false; applyPause(); });

    function toggleSticky(){
      stickyPaused = !stickyPaused;
      applyPause();
      try { localStorage.setItem(storageKey, String(stickyPaused)); } catch(e) {}
    }

    // Double-click to toggle sticky pause
    root.addEventListener('dblclick', function(e){ toggleSticky(); });

    // Double-tap detection for touch
    var lastTap = 0;
    root.addEventListener('touchend', function(){
      var now = Date.now();
      if (now - lastTap < 350) { toggleSticky(); }
      lastTap = now;
    });

    // Keyboard: Space or Enter toggles sticky pause; Escape clears sticky pause
    root.addEventListener('keydown', function(e){
      var key = e.key;
      if (key === ' ' || key === 'Enter') { e.preventDefault(); toggleSticky(); }
      if (key === 'Escape') { stickyPaused = false; applyPause(); try { localStorage.setItem(storageKey, 'false'); } catch(e) {} }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      initTicker(document.querySelector('.promo-ticker'));
    });
  } else {
    initTicker(document.querySelector('.promo-ticker'));
  }
})();
